<h1 mat-dialog-title>{{isNew ? 'Create information asset' : 'Edit information asset'}}</h1>
<mat-dialog-content [formGroup]="dialogForm" autocomplete="off">
  <p class="intro">An information asset is the information itself, such as a customer order. Information nodes are its states: received, checked, fulfilled. LINQ values the asset across all its states.</p>

  <mat-form-field class="full">
    <mat-label>Name</mat-label>
    <input type="text" matInput formControlName="name" [errorStateMatcher]="matcher" id="asset-name" [maxlength]="INFORMATION_ASSET_NAME_MAX" placeholder="For example Customer order" required>
    <mat-hint align="end">{{dialogForm.value.name?.length || 0}}/{{INFORMATION_ASSET_NAME_MAX}}</mat-hint>
    @if (dialogForm.controls['name'].hasError('required')) {
      <mat-error>Name is <strong>required</strong></mat-error>
    }@else if (dialogForm.controls['name'].hasError('duplicate')) {
      <mat-error>There is already an information asset with this name</mat-error>
    }@else if (dialogForm.controls['name'].invalid) {
      <mat-error>{{getNameError()}}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class="full">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description" [errorStateMatcher]="matcher" id="asset-description" [maxlength]="INFORMATION_ASSET_DESCRIPTION_MAX" rows="3"></textarea>
    <mat-hint align="end">{{dialogForm.value.description?.length || 0}}/{{INFORMATION_ASSET_DESCRIPTION_MAX}}</mat-hint>
    @if (dialogForm.controls['description'].hasError('maxlength')) {
      <mat-error>{{getDescriptionError()}}</mat-error>
    }
  </mat-form-field>

  <h2 class="section">Register</h2>
  <div class="register">
    <mat-form-field>
      <mat-label>Owner</mat-label>
      <mat-select formControlName="ownerKey" id="asset-owner">
        <mat-option [value]="null">No owner</mat-option>
        @for (r of roles; track r.key) {<mat-option [value]="r.key">{{r.name}}</mat-option>}
      </mat-select>
      <mat-hint>Accountable role</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Classification</mat-label>
      <mat-select formControlName="classification" id="asset-classification">
        <mat-option [value]="null">Not classified</mat-option>
        @for (c of classifications; track c.value) {<mat-option [value]="c.value">{{c.label}}</mat-option>}
      </mat-select>
      <mat-hint>How sensitive</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>System of record</mat-label>
      <mat-select formControlName="systemOfRecordKey" id="asset-system-of-record">
        <mat-option [value]="null">None set</mat-option>
        @for (s of systems; track s.key) {<mat-option [value]="s.key">{{s.name}}</mat-option>}
      </mat-select>
      <mat-hint>Its master copy</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="accent" cdkFocusInitial (click)="save()">{{isNew ? 'Create' : 'Save'}}</button>
</div>
